//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  // update a customer's email address
  // * data must include `email` and `current_password`
  updateEmail(data:Object) {
    Dispatcher.dispatchAction(Constants.UPDATE_CUSTOMER_DETAILS, data);
  },

  // updata a customer's password
  // * data must include `current_password`, `new_password` and `confirmation`
  updatePassword(data:Object) {
    Dispatcher.dispatchAction(Constants.UPDATE_CUSTOMER_DETAILS, data);
  },

  openEmailModal() {
    Dispatcher.dispatchAction(Constants.OPEN_EMAIL_MODAL);
  },

  closeEmailModal() {
    Dispatcher.dispatchAction(Constants.CLOSE_EMAIL_MODAL);
  },

  openPasswordModal() {
    Dispatcher.dispatchAction(Constants.OPEN_PASSWORD_MODAL);
  },

  closePasswordModal() {
    Dispatcher.dispatchAction(Constants.CLOSE_PASSWORD_MODAL);
  },
};
